import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriiDocumenteComponent } from './categorii-documente.component';
import { AddCategoriiDocumenteComponent } from './add-categorii-documente/add-categorii-documente.component';
import { EditCategoriiDocumenteComponent } from './edit-categorii-documente/edit-categorii-documente.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        CategoriiDocumenteComponent,
        AddCategoriiDocumenteComponent,
        EditCategoriiDocumenteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [CategoriiDocumenteComponent]
})
export class CategoriiDocumenteModule { }
